import type { UpdateManualSizeBiasBodyDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateManualSizeBiasProducts from "./use-invalidate-manual-size-bias-products";

type AddManualSizeBiasProductVariables = {
  productId: string;
  manualSizeBias: UpdateManualSizeBiasBodyDto["manualSizeBias"];
};

export default function useAddManualSizeBiasProduct(shopId: string) {
  const invalidate = useInvalidateManualSizeBiasProducts(shopId);

  return useApiMutation(
    "patch",
    "/shops/{shopId}/sizing/manual-bias/products/{productId}",
    {
      invalidate,
      mapVariables: ({
        productId,
        manualSizeBias,
      }: AddManualSizeBiasProductVariables) => ({
        params: { path: { shopId, productId } },
        body: { manualSizeBias },
      }),
    },
  );
}
